import React from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import {
  Typography,
  TableHead,
  TableRow,
  TableCell,
  Table,
  TableBody
} from '@material-ui/core';
import useStyles from './styles';

const headingsConfig = classes => {
  return {
    accommodationStatistics: {
      headings: [
        {
          label: 'Accommodation name',
          align: 'left',
          cellClassName: classes.unitCell
        },
        {
          label: 'Booked slots',
          align: 'right',
          cellClassName: classes.slotsNumberCell
        }
      ]
    },
    privateActivitiesStatistics: {
      headings: [
        {
          label: 'Activity name',
          align: 'left',
          cellClassName: classes.unitCell
        },
        {
          label: 'Booked slots',
          align: 'right',
          cellClassName: classes.slotsNumberCell
        }
      ]
    },
    openActivitiesStatistics: {
      headings: [
        {
          label: 'Activity name',
          align: 'left',
          cellClassName: classes.unitCell
        },
        {
          label: 'Booked seats',
          align: 'right',
          cellClassName: classes.slotsNumberCell
        }
      ]
    }
  };
};

const StatisticsBookingsList = ({
  tableTitle,
  statisticsType,
  bookingsData
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.tableWrapper}>
      <Typography className={classes.tableTitle} variant="h1">
        {t(tableTitle)}
      </Typography>
      <Table className={classes.table} aria-label="simple table">
        <TableHead className={classes.tableHead}>
          <TableRow>
            {headingsConfig(classes)[statisticsType].headings.map(heading => (
              <TableCell
                key={heading.label}
                align={heading.align}
                style={{ paddingBottom: 5 }}
                className={classNames(classes.heading, heading.cellClassName)}
              >
                {t(heading.label)}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {bookingsData &&
            bookingsData.map((booking, index) => (
              <TableRow key={index} classes={{ root: classes.tableRow }}>
                <TableCell
                  className={classNames(classes.tableCell, classes.unitCell)}
                  align="left"
                >
                  <Typography className={classes.unitTitle}>
                    {booking.title}
                  </Typography>
                </TableCell>
                <TableCell
                  className={classNames(
                    classes.tableCell,
                    classes.slotsNumberCell
                  )}
                  align="right"
                >
                  <Typography>
                    {booking.status === null
                      ? booking.total
                      : t(booking.status)}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default StatisticsBookingsList;
